import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  Wallet,
  WalletWhitelistAddressesResponse,
  WalletWhitelistAddressesQuery,
} from '../models/wallet.model';
import { ApiResponse } from '../models/api-response.models';

/**
 * All HTTP calls in this service return the standard
 * `ApiResponse<T>` envelope.
 */
@Injectable({
  providedIn: 'root',
})
export class SharedWalletService {
  private readonly baseUrl = `${environment.assetManagementApiUrl}/api/v1/wallet`;

  constructor(private http: HttpClient) {}

  getWalletDetails(
    walletId: string,
    addresses: boolean = false,
    settings: boolean = false,
    assetNetwork: boolean = false,
    vault: boolean = false
  ): Observable<ApiResponse<Wallet>> {
    const params = new URLSearchParams();
    if (addresses) params.append('addresses', 'true');
    if (settings) params.append('settings', 'true');
    if (assetNetwork) params.append('assetNetwork', 'true');
    if (vault) params.append('vault', 'true');

    const queryString = params.toString();
    const url = `${this.baseUrl}/${walletId}${queryString ? '?' + queryString : ''}`;

    return this.http.get<ApiResponse<Wallet>>(url);
  }

  getWalletWhitelistAddresses(
    walletId: string,
    query: WalletWhitelistAddressesQuery
  ): Observable<WalletWhitelistAddressesResponse> {
    const params = new HttpParams()
      .set('orderBy', query.orderBy)
      .set('order', query.order)
      .set('page', query.page.toString())
      .set('limit', query.limit.toString());

    return this.http.get<WalletWhitelistAddressesResponse>(
      `${this.baseUrl}/${walletId}/whitelist-addresses`,
      { params }
    );
  }
}
